<template>
  <div class="w3-modal" style="display: block" v-if="visivel">

    <div class="w3-modal-content w3-animate-zoom">
      <header class="w3-container">
        <span
          @click="fechar()"
          class="w3-button w3-display-topright w3-text-theme w3-large">&times;</span>

        <h5 class="w3-left w3-col m12 titulo" v-cloak>
          <b class="texto-vermelho">
            <i class="fa fa-map fa-fw"></i>
            <span>{{titulo}}</span>
          </b>
        </h5>
      </header>

      <div class="w3-row-padding">
        <div class="w3-col s12 m6">
          <label for="data-inicial" class="w3-col s12 m6">Data inicial</label>
          <input
            type="date"
            id="data-inicial"
            :disabled="dataInicialSomenteLeitura == 'S'"
            v-on:change="calcularQuantidadeDiasDataFinal()"
            class="w3-input w3-border"
            v-model="data_inicial"
          />          
        </div>

        <div class="w3-col s12 m6">
          <label for="data-final">Data final</label>
          <input
            type="date"
            id="data-final"
            :disabled="dataFinalSomenteLeitura == 'S'"
            class="w3-input w3-border"
            v-model="data_final"
          />

          <div class="w3-right-align">
            <label 
              v-if="quantidadeDiasDataFinal > 0"
              style="font-size:12px;"> 
              Qtd. dias: {{quantidadeDiasDataFinal}} 
            </label>
          </div>
        </div>
      </div>

      <footer class="w3-container conteudo-centralizado">
        <button
          class="w3-btn w3-theme"
          style="margin-top: 10px; margin-bottom:10px;"
          @click="confirmar()">
          <span>Confirmar</span>
        </button>
      </footer>

    </div>
  </div>
</template>

<script>
  import toastr from 'toastr';
  import moment from 'moment'
  import Biblioteca from '@/components/Repositorio/Biblioteca';

  export default {
    name: 'ColetarPeriodo',

    props: {
      dataInicialMinima: {
        type: String,
        default: '',
        required: false
      },

      dataInicialMaxima: {
        type: String,
        default: '',
        required: false
      },

      dataInicial: {
        type: String,
        default: '',
        required: false
      },

      dataInicialSomenteLeitura: {
        type: String,
        default: 'N',
        required: false
      },

      dataFinalMinima: {
        type: String,
        default: '',
        required: false
      },

      dataFinalMaxima: {
        type: String,
        default: '',
        required: false
      },

      dataFinal: {
        type: String,
        default: '',
        required: false
      },

      dataFinalSomenteLeitura: {
        type: String,
        default: 'N',
        required: false
      },

      maximoDias: {
        type: Number,
        default: 0,
        required: false
      },

      titulo: {
        type: String,
        default: 'Definir período',
        required: false
      },

      quantidadeDiasDataFinal: {
        type: Number,
        default: 0,
        required: false
      },

      obrigarDataInicialMaiorDataAtual: {
        type: String,
        default: 'N',
        required: false
      },
    },

    data() {
      const self = this;

      return {
        data_inicial: undefined,
        data_final: undefined,

        visivel: false
      }
    },

    methods: {
      calcularQuantidadeDiasDataFinal(){
        if
          (
            (!this.data_inicial) ||
            (Biblioteca.valor(this.quantidadeDiasDataFinal) <= 0)
          )
        {
          return;
        }

        this.data_final = Biblioteca.strToDate(Biblioteca.fData(this.data_inicial));
        this.data_final.setDate(this.data_final.getDate() + Biblioteca.valor(this.quantidadeDiasDataFinal));
        this.data_final = Biblioteca.fData(this.data_final);
        this.data_final = moment(this.data_final, 'DD/MM/YYYY').format('YYYY-MM-DD');
      },

      confirmar() {
        let dt_ini = Biblioteca.strToDate(Biblioteca.fData(this.data_inicial));
        
        if (!dt_ini) {
          toastr.error('Informe a data inicial!');
          return;
        }

        let dt_fin = Biblioteca.strToDate(Biblioteca.fData(this.data_final));
        if (!dt_fin) {
          toastr.error('Informe a data final!');
          return;
        }

        let dt_ini_min = Biblioteca.strToDate(this.dataInicialMinima);
        if ((dt_ini_min) && (dt_ini.getTime() < dt_ini_min.getTime())) {
          toastr.error('A data mínima inicial é ' + Biblioteca.fData(dt_ini_min) + '!');
          return;
        }

        let dt_fin_min = Biblioteca.strToDate(this.dataFinalMinima);
        if ((dt_fin_min) && (dt_ini.getTime() > dt_fin_min.getTime())) {
          toastr.error('A data mínima inicial é ' + Biblioteca.fData(dt_fin_min) + '!');
          return;
        }

        let dt_ini_max = Biblioteca.strToDate(this.dataInicialMaxima);
        if ((dt_ini_max) && (dt_ini.getTime() > dt_ini_max.getTime())) {
          toastr.error('A data mínima inicial é ' + Biblioteca.fData(dt_ini_max) + '!');
          return;
        }

        let dt_fin_max = Biblioteca.strToDate(this.dataFinalMaxima);
        if ((dt_fin_max) && (dt_ini.getTime() < dt_fin_max.getTime())) {
          toastr.error('A data mínima inicial é ' + Biblioteca.fData(dt_fin_max) + '!');
          return;
        }

        if (dt_ini.getTime() > dt_fin.getTime()) {
          toastr.error('A data inicial não pode ser maior que a data final!');
          return;
        }

        if (this.maximoDias > 0) {
          let data_maxima = Biblioteca.strToDate(dt_ini);
          data_maxima.setDate(data_maxima.getDate() + this.maximoDias);

          if (data_maxima.getTime() < dt_fin.getTime()) { 
            toastr.error('O período deve ter um intervalo máximo de ' + this.maximoDias + ' dias!');
            return;
          }
        }

        if (this.obrigarDataInicialMaiorDataAtual == 'S'){
          let data_atual = Biblioteca.strToDate(Biblioteca.fData(new Date()));

          if (dt_ini < data_atual){
            toastr.error('A data inicial não pode ser menor que hoje!');
            return;
          }
        }

        let retorno = {
          data_inicial: Biblioteca.fData(dt_ini),
          data_final: Biblioteca.fData(dt_fin)
        }

        this.$emit('confirmar', retorno);
        this.fechar();
      },

      abrir() {
        this.data_inicial = Biblioteca.fDataInternacional(this.dataInicial);
        this.data_final = Biblioteca.fDataInternacional(this.dataFinal);
        this.visivel = true;
      },

      fechar() {
        this.visivel = false;
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/ColetarPeriodo.vue